var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8264627911581665178(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 30.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M40 4.5c.3 0 .5-.6.5-1.2.1-.7-.2-1.3-.5-1.3H8.1c-.3 0-.5.6-.5 1.3 0 .7.2 1.2.5 1.2h1.2V3.3h29.5v1.2H40zM38.9 24.2v.5H17.2c0-.2 0-.4-.1-.5-.4-2.1-2.3-3.7-4.5-3.7H7c-2.5 0-4.6 2.1-4.6 4.6v2.2h14.9v-2.1H40c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-1.1zm-27.2 2.3H8L7 21H12.7l-1 5.5zM9.4 20.5h1.4v-.6c-.3.1-.6.1-1 .1h-.5v.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M17.2 24.2c0 .2.1.4.1.5h21.6V3.3H9.4v7h.5c.3 0 .6 0 .9.1V4.5h26.7v19.7H17.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.8 19.9v.6h1.9c2.2 0 4.1 1.6 4.5 3.7h20.3V4.5H10.8v5.8c2.3.4 3.9 2.4 3.9 4.8s-1.7 4.4-3.9 4.8zm24.4-.1h-.7l.7-.9v.9zm0-1.1l-.9 1.2h-.7l1.6-2.1v.9zm0-1.1l-1.8 2.3h-.7l2.5-3.2v.9zm0-1.2l-2.7 3.4h-.7l3.4-4.4v1zm0-1.1l-3.6 4.6h-.7l4.3-5.5v.9zm-4.8-8.5h.7l-.7.9v-.9zm0 1.1l.9-1.1h.7l-1.6 2v-.9zm0 1.1l1.8-2.3h.8l-2.5 3.2V9zm0 1.2l2.7-3.4h.7l-3.4 4.3v-.9zm0 1.1L34 6.8h.7l-4.3 5.4v-.9zm0 1.1l4.5-5.7h.3v.6l-4.8 6v-.9zm0 1.2l4.8-6v.9l-4.8 6v-.9zm0 1.1l4.8-6v.9l-4.8 6v-.9zm0 1.2l4.8-6v.9l-4.8 6v-.9zm0 1.1l4.8-6v.9l-4.8 6V17zm0 1.1l4.8-6v.9l-4.8 6v-.9zm0 1.2l4.8-6v.9l-4.5 5.7h-.2v-.6zm-6.8-8h4.8v8.6h-4.8v-8.6zm-6.8 4.1h4.8v4.5h-4.8v-4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M9.8 10.2h-.5c-2.5.2-4.4 2.3-4.4 4.9 0 2.5 1.9 4.6 4.4 4.9h.5c.3 0 .6 0 .9-.1 2.3-.4 3.9-2.4 3.9-4.8s-1.7-4.4-3.9-4.8c-.2 0-.5-.1-.9-.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M10.4 22.8l.6 3.7h.7l1.1-5.5H7l1 5.5h.7l.6-3.7-.6-1h2.2l-.5 1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M8.7 26.5H11l-.6-3.7.5-1H8.7l.6 1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#616E7D",
    d: "M16.8 15.4h4.8v4.5h-4.8zM23.6 11.3h4.8v8.6h-4.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#AAD3C7",
    d: "M35.2 16.4v-.9l-3.4 4.4h.7zM35.2 15.3v-.9l-4.3 5.5h.7zM31.2 6.8h-.8v.9zM35.2 9.6v-.9l-4.8 6v.9zM35.2 10.7v-.9l-4.8 6.1v.9zM30.7 19.9l4.5-5.8v-.9l-4.8 6.1v.6zM35.2 8.5v-.9l-4.8 6v.9zM35.2 13v-.9l-4.8 6v.9zM30.4 8.8l1.7-2h-.8l-.9 1.1zM35.2 11.9V11l-4.8 6v.9zM30.4 11.1l3.5-4.3h-.8l-2.7 3.4zM35.2 18.7v-.9l-1.6 2.1h.7zM35.2 19.8v-.9l-.7 1h.7zM30.4 12.2l4.4-5.4H34l-3.6 4.5zM35.2 17.6v-.9l-2.5 3.2h.7zM30.4 9.9L33 6.8h-.8L30.4 9zM30.4 13.3l4.8-6v-.5h-.3l-4.5 5.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8264627911581665178);
export default __webpack_public_path__ + "static/media/8264627911581665178.1705b6db0ec8ba554471b1f4915917b1.svg";
export { ForwardRef as ReactComponent };